import { useMemo } from "react";

import { countFiltersBySection } from "../utils/companyEnrichFilterSections";

import { CreateCompanyEnrich } from "../schema/companyEnrich";

export interface CompanyEnrichFilterCounts {
	personFilterCount: number;
	companyFilterCount: number;
	advancedSearchFilterCount: number;
	fundingFilterCount: number;
	workforceGrowthFilterCount: number;
	locationFilterCount: number;
	excludeCompaniesFilterCount: number;
}

/**
 * Derive the active-filter count badges shown on each section of the Company Enrich form.
 * The field-to-section mapping lives in `companyEnrichFilterSections` so the badges and the
 * initial expanded state of each section can never disagree about what counts as a filter.
 */
export const useCompanyEnrichFilterCounts = (
	formValues: Partial<CreateCompanyEnrich>
): CompanyEnrichFilterCounts =>
	useMemo(() => {
		const counts = countFiltersBySection(formValues);

		return {
			personFilterCount: counts.person,
			companyFilterCount: counts.company,
			advancedSearchFilterCount: counts.advancedSearch,
			fundingFilterCount: counts.funding,
			workforceGrowthFilterCount: counts.workforceGrowth,
			locationFilterCount: counts.location,
			excludeCompaniesFilterCount: counts.excludeCompanies,
		};
	}, [formValues]);
